module.exports = __webpack_public_path__ + "fonts/cdba3cd124545eab48ef5b3a5cbec7f3.svg";